import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContribuinteDs } from "../../DataSources";
import memoria from "../../Memoria";

const localStorageKey = "cadastroContribuinteGridState";

export default class ContribuinteBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { nome: "", status: 0 },
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.contribuinteDs = criarContribuinteDs();

    this.statusOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: -1, descricao: "TODOS" },
        { id: 0, descricao: "ATIVOS" },
        { id: 1, descricao: "INATIVOS" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("contribuintes/editar/" + e.data.id);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (
      filtro.sequencial !== undefined &&
      filtro.sequencial !== "" &&
      filtro.sequencial !== null
    ) {
      filtroCorrente.push(["sequencial", "=", filtro.sequencial]);
    }
    if (filtro.nome !== undefined && filtro.nome !== "") {
      filtroCorrente.push(["nome", "contains", filtro.nome.trim()]);
    }
    if (filtro.status !== undefined && filtro.status >= 0) {
      filtroCorrente.push(["status", "=", filtro.status]);
    }
    if (filtro.cpfCnpj !== undefined && filtro.cpfCnpj !== "") {
      let cpfCnpj = filtro.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      filtroCorrente.push(["cpfCnpj", "contains", cpfCnpj.trim()]);
    }
    if (filtro.endereco !== undefined && filtro.endereco !== "") {
      filtroCorrente.push(["endereco", "contains", filtro.endereco.trim()]);
    }
    if (filtro.numero !== undefined && filtro.numero !== "") {
      filtroCorrente.push(["numero", "contains", filtro.numero.trim()]);
    }
    if (filtro.bairro !== undefined && filtro.bairro !== "") {
      filtroCorrente.push(["bairro", "contains", filtro.bairro.trim()]);
    }
    if (filtro.cidade !== undefined && filtro.cidade !== "") {
      filtroCorrente.push(["cidade", "contains", filtro.cidade.trim()]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: { nome: "", status: 0 } });
    this.filtrar();
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form id="frmPesquisa" formData={this.state.filtro} colCount={6} labelLocation="top">

              <SimpleItem dataField="nome" colSpan={4}>
                <Label text="Nome/Razão Social" />
              </SimpleItem>
              <SimpleItem
                dataField="sequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ step: 0, value: null }}
              >
                <Label text="Inscrição" />
              </SimpleItem>

            

              <SimpleItem dataField="apelido" colSpan={3}>
                <Label text="Fatansia/Apelido" />
              </SimpleItem>

              <SimpleItem dataField="cpfCnpj" colSpan={1}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>


              <SimpleItem dataField="endereco" colSpan={4}>
                <Label text="Endereco" />
              </SimpleItem>
              <SimpleItem dataField="numero">
                <Label text="N.º" />
              </SimpleItem>
              <SimpleItem dataField="bairro" colSpan={3}>
                <Label text="Bairro" />
              </SimpleItem>
              <SimpleItem dataField="cidade" colSpan={2}>
                <Label text="Cidade" />
              </SimpleItem>
              <SimpleItem
                dataField="status"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.statusOptions}
              >
                <Label text="Situação" />
              </SimpleItem>
            </Form>
            <br />
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br /> <br />
          <PaginaToolbar
            titulo="Lista de Contribuintes"
            novoCb={this.novoContribuinte.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.contribuinteDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />

              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column
                dataField={"sequencial"}
                visibleIndex={1}
                allowEditing={false}
                caption={"#"}
                width={80}
              >
                <FormItem visibleIndex={1} />
              </Column>
              <Column dataField={"id"} allowEditing={false} visible={false} />

              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"nome"} caption={"Nome"} />
              <Column dataField={"codigoRefProducao"} caption={"Cód. Ref. Produção"} visible={false} />
              <Column dataField={"cpfCnpj"} caption={"CPF/CNPJ"} />
              <Column dataField={"statusStr"} caption={"Situação"} />
              <Column dataField={"apelido"} caption={"Apelido"} />
              <Column dataField={"logradouroComNumero"} caption={"Endereço"} />
              <Column dataField={"bairro"} caption={"Bairro"} />
              <Column dataField={"cidade"} caption={"Cidade"} />
              <Column dataField={"uf"} caption={"UF"} />
              <Column dataField={"telefone"} caption={"Telefone"} />
              <Column dataField={"celular"} caption={"Celular"} />
              <Column dataField={"email"} caption={"E-mail"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoContribuinte() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("contribuintes/novo");
  }
}
